var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrizzle01 = function SvgDrizzle01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "drizzle-01_svg2__a",
    x1: 5.02,
    x2: 161.25,
    y1: 175.88,
    y2: 12.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__b",
    x1: 60.47,
    x2: 216.7,
    y1: 228.79,
    y2: 65.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__c",
    x1: 69.41,
    x2: 225.64,
    y1: 237.31,
    y2: 73.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__d",
    x1: 78.35,
    x2: 234.59,
    y1: 245.85,
    y2: 82.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__e",
    x1: 56.91,
    x2: 213.15,
    y1: 225.39,
    y2: 61.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__f",
    x1: 31.91,
    x2: 188.14,
    y1: 201.54,
    y2: 37.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__g",
    x1: 47.99,
    x2: 204.23,
    y1: 216.88,
    y2: 53.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__h",
    x1: 64.09,
    x2: 220.33,
    y1: 232.24,
    y2: 68.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__i",
    x1: 28.36,
    x2: 184.59,
    y1: 198.15,
    y2: 34.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__j",
    x1: 3.34,
    x2: 159.58,
    y1: 174.28,
    y2: 10.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__k",
    x1: 19.43,
    x2: 175.67,
    y1: 189.64,
    y2: 25.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#drizzle-01_svg2__a",
    id: "drizzle-01_svg2__l",
    x1: 35.53,
    x2: 191.76,
    y1: 204.99,
    y2: 41.23
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.19 28.27c-3.14 0-6.36.43-9.75 1.29C133.14 11.5 115.42 0 95.4 0 73.23 0 53.8 14.19 47.05 35.3c-.61 1.91.44 3.95 2.35 4.56 1.92.62 3.95-.44 4.56-2.35C59.75 19.42 76.41 7.26 95.41 7.26c16.88 0 31.86 9.56 39.1 24.65-4.98 2.28-8.43 5.64-10.55 8.33a3.637 3.637 0 0 0 .6 5.1c.67.52 1.46.78 2.24.78 1.07 0 2.14-.47 2.85-1.38 1.96-2.49 5.41-5.78 10.68-7.29.02 0 .1-.03.12-.04 3.87-1.26 7.37-1.88 10.72-1.88 19.18 0 34.78 15.6 34.78 34.79s-15.61 34.78-34.78 34.78H40.23c-14.45 0-26.2-11.75-26.2-26.2s11.76-26.2 26.2-26.2c2.13 0 4.36.35 7.01 1.09 3.47 1.05 6.7 2.93 9.08 5.3.71.71 1.63 1.06 2.56 1.06s1.86-.36 2.57-1.07a3.63 3.63 0 0 0-.01-5.13c-3.22-3.2-7.53-5.73-12.13-7.11h-.04c-.01 0-.02-.01-.03-.01-3.33-.93-6.19-1.37-9.01-1.37-18.45 0-33.46 15.01-33.46 33.46s15.01 33.46 33.46 33.46h110.95c23.18 0 42.04-18.86 42.04-42.04s-18.86-42.05-42.04-42.05",
    style: {
      fill: "url(#drizzle-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54 135.55c-.71 0-1.42-.14-2.08-.43-.64-.27-1.22-.66-1.72-1.15a5.344 5.344 0 0 1-.01-7.57s0-.01.01-.02c.5-.49 1.08-.87 1.72-1.15a5.25 5.25 0 0 1 4.15 0c1.69.72 2.99 2.27 3.29 4.28.24 1.62-.38 3.26-1.54 4.42l-.04.04c-1.01 1-2.37 1.56-3.79 1.57",
    style: {
      fill: "url(#drizzle-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17 148.09c0-2.97 2.4-5.37 5.37-5.37 2.96.02 5.35 2.41 5.37 5.37a5.403 5.403 0 0 1-5.37 5.37c-2.96 0-5.37-2.39-5.37-5.36Z",
    style: {
      fill: "url(#drizzle-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54 171.36c-.71 0-1.42-.14-2.08-.43-.64-.27-1.22-.66-1.72-1.15a5.344 5.344 0 0 1-.01-7.57s0-.01.01-.02c.5-.49 1.08-.87 1.72-1.15a5.25 5.25 0 0 1 4.15 0c1.69.72 2.99 2.27 3.29 4.28.24 1.62-.38 3.26-1.54 4.42l-.04.04c-1.01 1-2.37 1.56-3.79 1.57",
    style: {
      fill: "url(#drizzle-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.89 173.15c0-2.97 2.4-5.37 5.37-5.37 2.96.02 5.35 2.41 5.37 5.37a5.403 5.403 0 0 1-5.37 5.37c-2.96 0-5.37-2.39-5.37-5.36Zm0-21.48c0-2.97 2.4-5.37 5.37-5.37 2.96.02 5.35 2.41 5.37 5.37a5.403 5.403 0 0 1-5.37 5.37c-2.96 0-5.37-2.39-5.37-5.36Zm0-21.5c0-2.96 2.4-5.36 5.36-5.36h.01c2.96.02 5.35 2.41 5.37 5.37a5.403 5.403 0 0 1-5.37 5.37c-2.96 0-5.37-2.39-5.37-5.36v-.03Z",
    style: {
      fill: "url(#drizzle-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.98 135.55c-1.39 0-2.78-.48-3.75-1.48-1.68-1.72-2-4.05-1.18-5.97.27-.64.66-1.22 1.15-1.72a5.327 5.327 0 0 1 7.54-.05c.51.5.91 1.1 1.18 1.77 1.15 2.72-.12 5.87-2.84 7.02-.66.28-1.37.42-2.09.42Z",
    style: {
      fill: "url(#drizzle-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.61 173.15c0-2.59 1.84-4.87 4.4-5.29.79-.13 1.52-.1 2.34.1 2.37.57 4 2.74 4 5.18a5.42 5.42 0 0 1-5.37 5.39c-2.96 0-5.37-2.39-5.37-5.36Zm0-21.48c0-2.96 2.39-5.37 5.36-5.37h.01c2.96.02 5.35 2.41 5.37 5.37 0 2.96-2.39 5.37-5.36 5.37h-.01a5.32 5.32 0 0 1-5.37-5.27z",
    style: {
      fill: "url(#drizzle-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.98 200c-.96 0-1.91-.25-2.71-.77-2.57-1.67-3.19-4.47-2.23-6.67.27-.64.66-1.22 1.15-1.72a5.327 5.327 0 0 1 7.54-.05c.51.5.91 1.1 1.18 1.77.29.65.44 1.36.44 2.08 0 1.42-.57 2.79-1.57 3.8a5.49 5.49 0 0 1-3.8 1.57Z",
    style: {
      fill: "url(#drizzle-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.32 173.15a5.403 5.403 0 0 1 5.37-5.37c2.96 0 5.37 2.39 5.37 5.36 0 2.61-1.85 4.89-4.41 5.31-.33.05-.64.08-.96.07-2.97 0-5.37-2.4-5.37-5.37m0-21.48a5.403 5.403 0 0 1 5.37-5.37c2.96 0 5.37 2.39 5.37 5.36 0 2.98-2.4 5.39-5.37 5.39a5.403 5.403 0 0 1-5.37-5.37m0-21.5c0-2.97 2.4-5.37 5.37-5.37a5.32 5.32 0 0 1 5.37 5.27v.1c0 2.96-2.39 5.37-5.36 5.37h-.01a5.403 5.403 0 0 1-5.37-5.37",
    style: {
      fill: "url(#drizzle-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.41 135.55c-.71 0-1.42-.15-2.08-.43-.65-.24-1.24-.64-1.72-1.15a5.36 5.36 0 0 1-1.57-3.8c0-.71.14-1.42.42-2.08.54-1.3 1.57-2.33 2.86-2.86 2.73-1.16 5.87.12 7.03 2.85.28.66.42 1.37.42 2.09s-.15 1.42-.44 2.08a5.7 5.7 0 0 1-1.14 1.72 5.36 5.36 0 0 1-3.8 1.57Z",
    style: {
      fill: "url(#drizzle-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.04 173.15c0-2.96 2.39-5.37 5.36-5.37h.01c2.97 0 5.37 2.4 5.37 5.37a5.403 5.403 0 0 1-5.37 5.37 5.403 5.403 0 0 1-5.37-5.37m0-21.48a5.403 5.403 0 0 1 5.37-5.37c2.96.02 5.35 2.41 5.37 5.37 0 2.96-2.39 5.37-5.36 5.37h-.01c-2.97 0-5.37-2.4-5.37-5.37",
    style: {
      fill: "url(#drizzle-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.41 200c-.71 0-1.42-.15-2.08-.43-.64-.27-1.22-.66-1.72-1.15a5.344 5.344 0 0 1-.01-7.57s0-.01.01-.02c.5-.49 1.08-.87 1.72-1.15a5.25 5.25 0 0 1 4.15 0c1.3.53 2.33 1.56 2.86 2.86.58 1.32.58 2.83 0 4.15-.27.64-.65 1.22-1.14 1.72a5.33 5.33 0 0 1-3.8 1.57Z",
    style: {
      fill: "url(#drizzle-01_svg2__l)"
    }
  }));
};
export default SvgDrizzle01;